import { useCountryExternalLinks } from 'modules/common/hooks/useCountryExternalLinks'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useCtaModal } from 'modules/common/modals/useCtaModal/useCtaModal'
import { FatcaRefusedAccountModalContent } from './FatcaRefusedAccountModalContent'

export const useFatcaRefusedAccountModal = () => {
  const { t, i18n } = useTranslation('common-components')
  const externalLinks = useCountryExternalLinks()

  return useCtaModal({
    width: 'base',
    i18n,
    content: <FatcaRefusedAccountModalContent />,
    primaryButtonText: t('authenticatedGuard.fatcaRefusedModal.cta'),
    onPrimaryClick: () => {
      window.open(externalLinks.fatcaCGU, '_blank')?.focus()
    },
    shouldCloseOnOverlayClick: false,
    shouldCloseOnEsc: false,
    displayCloseHeaderButton: false,
    overlayTransitionType: 'transition-none',
  })
}
